// A one-shot, short-lived note that sign-in started from the new-project page,
// so the real session return (the API always lands on "/") can bring the member
// back to it. Only this fixed route is ever restored: no URL, query or draft is
// stored, and anything unexpected is discarded.

const KEY = 'gfc:signin-continuation';
export const CONTINUATION_PATH = '/projects/new';
export const CONTINUATION_TTL_MS = 10 * 60_000;

function storage(): Storage | null {
  try {
    return window.sessionStorage;
  } catch {
    return null;
  }
}

/** Called on the sign-in click: remembers /projects/new, and clears any older note for every other page. */
export function markSignInContinuation(pathname: string, now = Date.now()): void {
  try {
    if (pathname === CONTINUATION_PATH) storage()?.setItem(KEY, JSON.stringify({ v: 1, at: now }));
    else storage()?.removeItem(KEY);
  } catch {
    // Storage unavailable: sign-in still works and simply lands on the report.
  }
}

/** Reads and always removes the note; returns the fixed route only when it is well-formed and fresh. */
export function takeSignInContinuation(now = Date.now()): string | null {
  try {
    const store = storage();
    const raw = store?.getItem(KEY) ?? null;
    if (store === null || raw === null) return null;
    store.removeItem(KEY);
    const note = JSON.parse(raw) as unknown;
    if (typeof note !== 'object' || note === null) return null;
    const { v, at } = note as { v?: unknown; at?: unknown };
    return v === 1 && typeof at === 'number' && at <= now && now - at < CONTINUATION_TTL_MS ? CONTINUATION_PATH : null;
  } catch {
    return null;
  }
}

export function clearSignInContinuation(): void {
  try {
    storage()?.removeItem(KEY);
  } catch {
    // Nothing to clear when storage is unavailable.
  }
}
